import React, { useState, useCallback } from "react";
import { Select, Tag } from "antd";
import { ClockCircleOutlined } from "@ant-design/icons";
import axios from "axios";
import debounce from "lodash.debounce";
import moment from "moment";

const { Option } = Select;

// Select de un solo contacto del CRM con búsqueda remota
const SelectorContactoItem = ({
  headersToken,
  empresaId,
  value,
  onChange,
  placeholder = "Buscar contacto por nombre o teléfono...",
  style,
}) => {
  const [opciones, setOpciones] = useState([]);
  const [buscando, setBuscando] = useState(false);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const buscarContactos = useCallback(
    debounce((texto) => {
      setBuscando(true);
      axios
        .post(
          "contactos/selectContactosItem",
          { query: texto || "", empresaId },
          { headers: headersToken },
        )
        .then((r) => {
          if (r.data.success === 2) setOpciones(r.data.contactos || []);
        })
        .catch(() => {})
        .finally(() => setBuscando(false));
    }, 300),
    [empresaId, headersToken],
  );

  // El contacto seleccionado sigue visible aunque cambien las opciones de búsqueda.
  const opcionesVisibles = value
    ? [value, ...opciones.filter((o) => o._id !== value._id)]
    : opciones;

  return (
    <Select
      showSearch
      allowClear
      filterOption={false}
      onSearch={buscarContactos}
      onFocus={() => buscarContactos("")}
      loading={buscando}
      placeholder={placeholder}
      style={{ width: "100%", ...style }}
      value={value?._id}
      onChange={(id) => {
        onChange?.(opcionesVisibles.find((c) => c._id === id) || null);
      }}
      notFoundContent={buscando ? "Buscando..." : "No se encontraron contactos"}
    >
      {opcionesVisibles.map((contacto) => {
        const tieneVentana =
          contacto.ventanaAbiertaHasta &&
          moment(contacto.ventanaAbiertaHasta).isAfter();
        return (
          <Option key={contacto._id} value={contacto._id}>
            <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
              <span style={{ flex: 1 }}>
                {contacto.stringBuscar || contacto.nombre || contacto._id}
              </span>
              {tieneVentana && (
                <Tag
                  color="green"
                  style={{ margin: 0, fontSize: 10, lineHeight: "16px" }}
                  icon={<ClockCircleOutlined />}
                >
                  {moment(contacto.ventanaAbiertaHasta).format("HH:mm")}
                </Tag>
              )}
              {!contacto.numero && (
                <Tag
                  color="orange"
                  style={{ margin: 0, fontSize: 10, lineHeight: "16px" }}
                >
                  sin tel.
                </Tag>
              )}
            </span>
          </Option>
        );
      })}
    </Select>
  );
};

export default SelectorContactoItem;
